module.exports = __webpack_public_path__ + "img/slide-2.63790588.jpg";